import { render } from "./OrderPay.vue?vue&type=template&id=125a1762&lang=pug"
import script from "./OrderPay.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderPay.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__